/* src/app/pages/ui-kit/components/select-view/select-view.component.scss */
.box {
  width: 220px;
  display: flex;
  gap: 14px;
  align-items: center;
  margin-bottom: 30px;
}
::ng-deep pa-select .p-select {
  width: 220px !important;
}
::ng-deep pa-multi-select .p-multiselect {
  width: 220px !important;
}
form {
  display: block;
  max-width: 100%;
}
/*# sourceMappingURL=select-view.component.css.map */
